export default {"src":"/_next/static/media/AR-Button.f3787316.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};